// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1517":"7659f96a","3898":"0be1b944","6279":"58d36f3e","8184":"a78bd974","8660":"5b5e57d3"}[chunkId] + ".chunk.js";
};